import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.49012e-08 5.5C1.49012e-08 2.73858 2.23858 0.5 5 0.5H11C13.7614 0.5 16 2.73858 16 5.5V12.5C16 14.025 14.8622 15.2842 13.3892 15.475L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L13.0824 17.9966C13.0552 17.9989 13.0278 18 13 18H3C2.97224 18 2.94475 17.9989 2.91756 17.9966L1.70711 19.2071C1.31658 19.5976 0.683417 19.5976 0.292893 19.2071C-0.0976311 18.8166 -0.0976311 18.1834 0.292893 17.7929L2.6108 15.475C1.13781 15.2842 1.49012e-08 14.025 1.49012e-08 12.5V5.5ZM5.41421 15.5L4.91421 16H11.0858L10.5858 15.5H5.41421ZM2 6.5C2 5.94771 2.44771 5.5 3 5.5H13C13.5523 5.5 14 5.94771 14 6.5C14 7.05228 13.5523 7.5 13 7.5H3C2.44771 7.5 2 7.05228 2 6.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M7.5 7.5C6.94772 7.5 6.5 7.94772 6.5 8.5V9.5C6.5 10.0523 6.94772 10.5 7.5 10.5H8.5C9.05228 10.5 9.5 10.0523 9.5 9.5V8.5C9.5 7.94772 9.05228 7.5 8.5 7.5H7.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5 1.5C5.05228 1.5 5.5 1.94772 5.5 2.5V3.5L8.5 3.5V2.5C8.5 1.94772 8.94772 1.5 9.5 1.5C10.0523 1.5 10.5 1.94772 10.5 2.5V3.5C10.5 3.55652 10.4953 3.61194 10.4863 3.6659C11.6586 4.07384 12.5 5.18867 12.5 6.5L12.5 10.5C12.5 12.1569 11.1569 13.5 9.5 13.5L4.5 13.5C2.84315 13.5 1.5 12.1569 1.5 10.5L1.5 6.5C1.5 5.18867 2.34136 4.07385 3.5137 3.6659C3.50469 3.61194 3.5 3.55652 3.5 3.5V2.5C3.5 1.94772 3.94772 1.5 4.5 1.5ZM3.5 6.5C3.5 5.94772 3.94772 5.5 4.5 5.5H9.5C10.0523 5.5 10.5 5.94772 10.5 6.5L10.5 10.5C10.5 11.0523 10.0523 11.5 9.5 11.5L4.5 11.5C3.94772 11.5 3.5 11.0523 3.5 10.5L3.5 6.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.5 14.5C6.94772 14.5 6.5 14.9477 6.5 15.5C6.5 17.025 7.63781 18.2842 9.1108 18.475L6.79289 20.7929C6.40237 21.1834 6.40237 21.8166 6.79289 22.2071C7.18342 22.5976 7.81658 22.5976 8.20711 22.2071L9.41756 20.9967C9.44475 20.9989 9.47224 21 9.5 21L19.5 21C19.5278 21 19.5553 20.9989 19.5824 20.9967L20.7929 22.2071C21.1834 22.5976 21.8166 22.5976 22.2071 22.2071C22.5976 21.8166 22.5976 21.1834 22.2071 20.7929L19.8892 18.475C21.3622 18.2842 22.5 17.025 22.5 15.5L22.5 8.5C22.5 5.73858 20.2614 3.5 17.5 3.5L15.5 3.5C14.9477 3.5 14.5 3.94772 14.5 4.5C14.5 5.05228 14.9477 5.5 15.5 5.5H17.5C19.1569 5.5 20.5 6.84315 20.5 8.5V9.5L16.5 9.5C15.9477 9.5 15.5 9.94772 15.5 10.5C15.5 11.0523 15.9477 11.5 16.5 11.5L20.5 11.5L20.5 15.5C20.5 16.0523 20.0523 16.5 19.5 16.5L9.5 16.5C8.94772 16.5 8.5 16.0523 8.5 15.5C8.5 14.9477 8.05228 14.5 7.5 14.5ZM11.4142 19L11.9142 18.5L17.0858 18.5L17.5858 19L11.4142 19Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fill)
    ? (_openBlock(), _createBlock("svg", _hoisted_1, [
        _hoisted_2
      ]))
    : (_openBlock(), _createBlock("svg", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]))
}